import React from 'react';

import Aligner from 'components/Aligner';
import Logo from './Logo';
import TopMenu from './TopMenu';
import UserBar from './UserBar';

import './topBar.scss';

const TopBar = () => (
  <div className="top-bar">
    <Logo />
    <Aligner className="top-nav">
      <TopMenu
        nav={[
          {title: 'Strategies', url: '/strategies'},
          {title: 'Account', url: '/account'},
          {title: 'Stats', url: '/stats/settled'},
        ]}
      />
    </Aligner>
    <UserBar />
  </div>
);

export default TopBar;
